import { useState } from "react";
import { ConciliationDateFormState } from "../category.types";
import { DateUtils } from "shared/dateUtils";
import { CONCILIATION_DATE_PICKER_FORMAT } from "../utils/category.utils";

type UseEditConciliationDateFormProps = {
  conciliationStartDate: string | null;
  updateConciliationDate: (date: string) => Promise<void>;
};

export function useEditConciliationDateForm({
  conciliationStartDate,
  updateConciliationDate,
}: UseEditConciliationDateFormProps) {
  const initialValue =
    conciliationStartDate != null
      ? DateUtils.utc(conciliationStartDate).format(
          CONCILIATION_DATE_PICKER_FORMAT
        )
      : null;

  const isEditingDate = initialValue != null;

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false);
  const [formState, setFormState] = useState<ConciliationDateFormState>({
    conciliationStartDate: { value: initialValue, error: false },
  });

  const handleChangeDate = (value: string | null) => {
    setFormState((prevState) => ({
      ...prevState,
      conciliationStartDate: { value, error: false },
    }));
  };

  const handleToggleDateError = (hasError: boolean) => {
    setFormState((prevState) => ({
      ...prevState,
      conciliationStartDate: {
        ...prevState.conciliationStartDate,
        error: hasError,
      },
    }));
  };

  const handleOpenConfirmModal = () => {
    setIsConfirmModalOpen(true);
  };

  const handleCloseConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  const handleSubmit = async () => {
    if (
      formState.conciliationStartDate.error === true ||
      formState.conciliationStartDate.value == null
    ) {
      return;
    }

    await updateConciliationDate(formState.conciliationStartDate.value);
    setIsConfirmModalOpen(false);
  };

  return {
    formState,
    handleChangeDate,
    handleCloseConfirmModal,
    handleOpenConfirmModal,
    handleSubmit,
    handleToggleDateError,
    isConfirmModalOpen,
    isEditingDate,
  };
}
